/*
import {
  hf,
  ht,
  cr,
  a,
  BoxC,
  BtnC,
  GridC,
  MsgC,
  SrlC,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as SrlC from "./_ccbSrlC";
import * as GridC from "./_cccGridC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as ht from './_ht';

import * as icvI17Ti from './icvI17___Ti';

export const O = (pz: {
  sPz: ht.dz,
}) => {

  return (
    cr.c(BoxC.N, {
      key: -10,
      abtType: 'bdyCmnz',
      oClds: [

        cr.c(GridC.N, {
          key: -10,
          abtType: 'barFtnStfz',
          boxStlz: a(`mb/2`),
        }),

        cr.c(BoxC.N, {
          key: -20,
          abtType: 'cttCmnz',
          oClds: [

/*
            cr.c(MsgC.N, {
              key: -10,
              abtType: 'cttCmnz',
              boxStlz: a('mb/2'),
              cz: {
                ls: [
                  {
                    mkrCz: {
                      textz: {
                        pfx: _lblz.msgz.topz.mkr,
                      }
                    },
                    msgCz: {
                      textz: {
                        pfx: _lblz.msgz.topz.msg,
                      }
                    }
                  },
                ]
              }
            }),
*/
            cr.c(SrlC.V, {
              key: -30,
              abtType: 'cttCmnz',
              oClds: [

                cr.c(icvI17Ti.L, {
                  key: -10,
                  sPz: pz.sPz,
                })
              ],
            }),

            cr.c(icvI17Ti.B, {
              key: -40,
              sPz: pz.sPz,
              cz: {
                lblz: pz.sPz.crt.lblz,
                sc: 'gn7',
                onPrsBack: () => {
                  cr.moveTo({
                    pageName: 'icvHomeS40Rz',
                  });
                }
              }
            })

          ]
        })

      ]
    })
  );
};
